import tags from "assets/images/Tag.png";
import tagActive from "assets/images/TagActive.png";
import challengesOrg from "assets/images/challengeIconBig.png";
import challenges from "assets/images/challenges.png";
import faqActive from "assets/images/faq_bowl_active.png";
import faqDefault from "assets/images/faq_bowl_default.png";
import ingredients from "assets/images/ingredients.png";
import ingredientsOrg from "assets/images/ingredients_orange.png";
import push_notificationsOrg from "assets/images/new_notification_icon.png";
import push_notifications from "assets/images/push_notifications.png";
import products from "assets/images/products.png";
import featured from "assets/images/featured.png";
import featuredOrg from "assets/images/featured-orange.png";
import fullyfit from "assets/images/fullyfit.png";
import fullyfitOrg from "assets/images/fullyfit-orange.png";
import productOrg from "assets/images/productOrg.png";
import recipesOrg from "assets/images/recipes-orange.png";
import recipes from "assets/images/recipes.png";
import userOrg from "assets/images/user-orange.png";
import user from "assets/images/user.png";
import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { getUser } from "helpers/localStorage";
import { NAV_ITEMS, canAccess } from "config/permissions";
import "./sideBar.css";

const NAV_ICONS = {
  "/dashboard": { img: user, img2: userOrg },
  "/groups": { img: user, img2: userOrg },
  "/full-circle": { img: user, img2: userOrg },
  "/admins": { img: user, img2: userOrg },
  "/ingredients": { img: ingredients, img2: ingredientsOrg },
  "/recipes": { img: recipes, img2: recipesOrg },
  "/categories": { img: tagActive, img2: tags },
  "/meal-Plans": { img: challenges, img2: challengesOrg },
  "/products": { img: products, img2: productOrg },
  "/featured": { img: featured, img2: featuredOrg },
  "/fully-fit": { img: fullyfit, img2: fullyfitOrg },
  "/push-notifications": { img: push_notifications, img2: push_notificationsOrg },
  "/faq": { img: faqDefault, img2: faqActive },
  "/users": { img: user, img2: userOrg },
  "/reports": { img: faqDefault, img2: faqActive },
};

const SideBar = ({ openSidebar, isSidebar }) => {
  const location = useLocation();
  const pageTitle = location.pathname;
  const user = getUser();

  const sidebarContent = useMemo(
    () =>
      NAV_ITEMS.filter((item) => canAccess(item.pathname, user?.type)).map(
        (item) => ({
          ...item,
          ...NAV_ICONS[item.pathname],
        })
      ),
    [user?.type]
  );

  return (
    <div className="left_bar topnav">
      <ul
        className={`myLinks ${isSidebar === true ? "menu-block" : "menu-none"}`}
      >
        {sidebarContent.map((sidebar) => (
          <React.Fragment key={sidebar.pathname}>
            <li>
              <Link
                to={sidebar.pathname}
                className={`${
                  sidebar.activeTab.includes(pageTitle) ? "active" : ""
                }`}
                onClick={() =>
                  sessionStorage.setItem("activeTab", "shoppingAisles")
                }
              >
                <span>
                  <img
                    src={
                      sidebar.activeTab.includes(pageTitle)
                        ? sidebar.img2
                        : sidebar.img
                    }
                    alt={sidebar.img}
                    className="category_select_icon"
                  />
                  {sidebar.name}
                </span>
                <i className="fa-solid fa-angle-right"></i>
              </Link>
            </li>
          </React.Fragment>
        ))}
      </ul>
      <Link to="#" className="icon" onClick={openSidebar}>
        <span></span>
        <span></span>
        <span></span>
      </Link>
    </div>
  );
};

export default SideBar;
